import { render } from "./VideoPanel.vue?vue&type=template&id=dc73c4e0&scoped=true"
import script from "./VideoPanel.vue?vue&type=script&lang=js"
export * from "./VideoPanel.vue?vue&type=script&lang=js"

import "./VideoPanel.vue?vue&type=style&index=0&id=dc73c4e0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc73c4e0"]])

export default __exports__